module.exports = __webpack_public_path__ + "2ddae912fc4fea0411e8d8ddedb39f79.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/graviton_-_agudaboldunicase-webfont.woff
// module id = 1314
// module chunks = 28